import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Gift } from 'react-feather';

import { Loading, Seo } from 'components/standalone';
import { Card } from 'styles/Commons';
import { Button } from 'styles/Form';
import AuthService from 'services/AuthService';
import TransferService from 'services/TransferService';
import TransferAcceptResponse from 'components/tickets/TransferAcceptResponse/TransferAcceptResponse';
import * as S from './styles';

const TicketTransferAcceptPage = () => {
	const { token } = useParams();
	const history = useHistory();
	const location = useLocation();

	const [transfer, setTransfer] = useState<any>(null);
	const [isLoading, setIsLoading] = useState(true);
	const [isAccepting, setIsAccepting] = useState(false);
	const [result, setResult] = useState<{ error: boolean; message: string } | null>(null);

	useEffect(() => {
		if (!AuthService.isAuthenticated()) {
			history.push({ pathname: '/entrar', state: { previousUrl: location.pathname } });
			return;
		}

		TransferService.getTransferByToken(token)
			.then(({ data }: any) => setTransfer(data))
			.catch(({ data }: any) => setResult({ error: true, message: data && data.detail ? data.detail : 'Transferência inválida ou expirada' }))
			.finally(() => setIsLoading(false));
	}, [token]);

	const accept = () => {
		setIsAccepting(true);
		TransferService.acceptTransfer(token)
			.then(({ data }: any) => setResult({ error: false, message: data && data.message ? data.message : 'Transferência aceita com sucesso' }))
			.catch(({ data }: any) => setResult({ error: true, message: data && data.detail ? data.detail : 'Não foi possível aceitar a transferência' }))
			.finally(() => setIsAccepting(false));
	}

	if (isLoading) {
		return <Loading text="Validando transferência" />;
	}

	if (result) {
		return <TransferAcceptResponse error={result.error} message={result.message} />;
	}

	return (
		<>
			<Seo title={`${process.env.REACT_APP_NAME} - Aceitar transferência`} />
			<S.Wrapper>
				<Card padding="2.5rem 2rem">
					<S.Content>
						<S.IconBadge>
							<Gift size={34} />
						</S.IconBadge>

						<S.Title>Você recebeu um ingresso!</S.Title>
						<S.Subtitle>
							<strong>{transfer && transfer.fromName}</strong> transferiu um ingresso para você. Confira os detalhes e aceite para que ele passe a fazer parte da sua conta.
						</S.Subtitle>

						{transfer && (
							<S.TicketStub>
								<S.StubHeader>Ingresso</S.StubHeader>
								<S.StubBody>
									<S.EventName>{transfer.eventName}</S.EventName>
									<S.Divider />
									<S.InfoGrid>
										<S.InfoItem>
											<S.InfoLabel>Tipo</S.InfoLabel>
											<S.InfoValue>{transfer.ticketName}</S.InfoValue>
										</S.InfoItem>
									</S.InfoGrid>
								</S.StubBody>
							</S.TicketStub>
						)}

						<Button width="100%" onClick={accept} loading={isAccepting}>Aceitar ingresso</Button>
					</S.Content>
				</Card>
			</S.Wrapper>
		</>
	);
}

export default TicketTransferAcceptPage;
